import React from 'react';
import styles from './LaboratoryRequestMaterials.module.scss';

interface Props {
	materials: { code: string; name: string; color: string }[];
}

const LaboratoryRequestMaterials: React.FC<Props> = ({ materials }) => {
	return (
		<div className={styles.wrapper}>
			{materials.map(material => (
				<div
					className={styles.material}
					style={{ backgroundColor: material.color }}
				/>
			))}
		</div>
	);
};

export default LaboratoryRequestMaterials;
